/* The colours the scrim offers.
 *
 * NOT in the component, and not because a test objects. tests/test_palette.py
 * forbids a raw hex in a .vue so that the interface follows the theme in both
 * light and dark -- and these are the opposite of that. A black scrim has to
 * be black on a dark background too: it is applied to the visitor's picture,
 * not painted on our page, so a colour that changed with the theme would be a
 * bug. Subject matter rather than interface, kept where subject matter lives.
 *
 * Black first because darkening a photograph so text can be read on it is what
 * this is for; the rest are what a brand tint actually reaches for. A native
 * <input type="color"> was the alternative: inconsistent across platforms,
 * worse on a phone, and slower than the two taps this needs.
 *
 * `key` names a catalogue entry under `colours.` so the label is translated;
 * the hex is what usableOverlay() in imageTransform.js validates.
 */
export const OVERLAY_COLOURS = [
	{key: "black", hex: "#000000"},
	{key: "white", hex: "#ffffff"},
	{key: "navy", hex: "#1b2a4a"},
	{key: "plum", hex: "#4636b3"},
	{key: "rose", hex: "#b3365e"},
	{key: "sand", hex: "#c8a06a"},
	{key: "lightGreen", hex: "#90ee90"},
	{key: "yellow", hex: "#ffd60a"},
]
